module.exports = __webpack_public_path__ + "static/img/1.9df916c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/share/images/1.jpg
// module id = ROR3
// module chunks = 52